/**
 * Helper functions that do some common string formatting.
 */

import { QuickShareCodeChunk } from 'src/reducers/config/types';

/**
 * Generates a one line address formatted to match prescription information card on patient profile.
 */
export const oneLineAddress = (address: Address): string => {
  return (
    address.address1 +
    (address.address2 ? ' ' + address.address2 : '') +
    ', ' +
    address.city +
    ',' +
    (address.state ? ' ' + address.state : '') +
    ' ' +
    address.zip
  );
};

export const getFullNameWithInitial = (account: Partial<User>): string => {
  if (!account || (!account.firstName && !account.lastName)) {
    return '';
  }

  const { firstName, middleInitial, lastName } = account;

  return (
    (firstName ? firstName + ' ' : '') + (middleInitial ? middleInitial + '. ' : '') + lastName
  );
};

export const getNameForFilePath = (account: User): string => {
  if (!account || (!account.firstName && !account.lastName)) {
    return '';
  }

  const { firstName, lastName } = account;

  return (firstName ? firstName : '') + lastName;
};

/**
 * Generates a formatted quick share code using the provided quickShareCodeConfig.
 */
export const getQuickShareCode = (
  code: string,
  separator: string,
  configChunks: QuickShareCodeChunk[]
): string => {
  if (!separator) {
    return code;
  }

  const characters = code.split('');
  const chunks: string[] = [];

  configChunks.forEach((cc) => {
    const codeChunk = characters.splice(0, cc.length).join('');

    chunks.push(codeChunk);
  });

  if (characters.length) {
    chunks.push(characters.join(''));
  }

  return chunks.join(separator);
};

/**
 * Returns string representing the quick share code lifetime in hours.
 */
export const getQuickShareCodeLifetimeHours: (lifetimeMinutes: number) => string = (
  lifetimeMinutes
) => {
  return lifetimeMinutes % 60 ? (lifetimeMinutes / 60).toFixed(2) : `${lifetimeMinutes / 60}`;
};
